import { PAGE_URLS } from 'utils/constants';
import COLORS from '../../constants/colors';
import {
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
  getPersonName,
  getPhoneNumber,
} from '../../details';

export const transform = (list, globalDepartmentList = []) => {
  return list.map(data => ({
    id: data.id,
    pageName: PAGE_URLS.SITES.link,
    surfaces: getItemOrDefaultToValue(data, 'surfaces', []),
    name: getItemOrDefaultToValue(data, 'name'),
    label: getItemOrDefaultToValue(data, 'label'),
    siteId: getItemOrDefaultToValue(data, 'siteId', '-'),
    siteName: getItemOrDefaultToValue(data, 'name', '-'),
    businessClient: data.businessClient,
    businessClientName: getItemOrDefaultToValue(
      data.businessClient,
      'businessClientName',
      '-',
    ),
    businessClientId: getItemOrDefaultToValue(data.businessClient, 'id', '-'),
    contactName:
      data.contact != null ? getPersonName(data.contact.general) : '-',
    contactNumber:
      data.contact != null
        ? getPhoneNumber(data.contact.general.phoneNumber)
        : '-',
    numCurrentVisitors: getItemOrDefaultToValue(data, 'numCurrentVisitors', 0),
    guardAssigned: getItemOrDefaultToValue(data, 'guardAssigned', '-'),
    patrols: getItemOrDefaultToValue(data, 'patrols', '-'),
    inductionRequired: getItemOrDefaultToValue(data, 'inductionRequired', '-'),
    locationDetail:
      data.boundary != null
        ? [
            {
              color: COLORS.DARK_GREY_02,
              isFilled: true,
              paths: getItemOrDefaultToValue(data.boundary, 'points').map(
                point => ({
                  lat: point.latitude,
                  lng: point.longitude,
                }),
              ),
            },
          ]
        : [],
    centreOfGravity: getItemOrDefaultToValue(
      data.boundary,
      'centreOfGravity',
      null,
    ),
    // this key displays the department names in the list view
    departments:
      data?.departmentIds && globalDepartmentList.length > 0
        ? getDepartmentNamesArray(globalDepartmentList, data)
        : [],
    assignedDepartmentList: data?.departmentIds ? data?.departmentIds : [],
  }));
};
